import React, { useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Foooter from "../components/Foooter";
import { useDispatch, useSelector } from "react-redux";
import { fetchPublicAnnouncements } from "../redux/reducers/trialSlice";

const bannerStyles = {
  info: "bg-blue-600",
  warning: "bg-yellow-500",
  update: "bg-purple-600",
  promotion: "bg-green-600",
};

const MainLayout = ({ children, ...props }) => {
  const dispatch = useDispatch();
  const { announcements } = useSelector((state) => state.trial);
  const active = announcements?.filter((a) => a.active) ?? [];

  useEffect(() => {
    dispatch(fetchPublicAnnouncements());
  }, [dispatch]);

  return (
    <div className="flex md:flex-row min-h-screen w-full">
      <Sidebar />
      <div className="flex-1 min-h-screen overflow-auto w-full">
        <div className="flex flex-col justify-between min-h-screen h-screen overflow-auto">
          {/* Announcement banners */}
          {active.map((ann) => (
            <div key={ann._id} className={`${bannerStyles[ann.type] || "bg-gray-700"} text-white text-xs text-center py-2 px-4`}>
              <strong>{ann.title}:</strong> {ann.message}
            </div>
          ))}
          <div className="p-2 sm:p-3 md:p-5">
            {children}
          </div>
          <div className="sticky bottom-0 w-full">
            <Foooter />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
